import { defineMessages } from 'react-intl'

const scope = `procurify.components.Budgets.BudgetCategoryExporterModal`

export default defineMessages({
  budgetsExporterModalTitle: {
    id: `${scope}.budgetsExporterModalTitle`,
    defaultMessage: 'Export budgets',
  },
  includeSpendToggleLabel: {
    id: `${scope}.includeSpendToggleLabel`,
    defaultMessage: 'Include spend',
  },
  budgetDateRangeLabel: {
    id: `${scope}.budgetDateRangeLabel`,
    defaultMessage: 'Budget date range',
  },
  budgetsToExportLabel: {
    id: `${scope}.budgetsToExportLabel`,
    defaultMessage: 'Budgets to export',
  },
})
